import { Component, OnInit, ViewChild } from '@angular/core';
import { MemberService } from '@asambleas-services/member/member.service';
import { MatPaginator, MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { Role } from '@asambleas-models/role.model';
import { RolesService } from '@asambleas-services/roles/roles.service';
import { EditRoleComponent } from '../edit-role/edit-role.component';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { TABLES_CONFIG } from '@asambleas-env/environment';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';

@Component({
    selector: 'app-list-roles',
    templateUrl: './list-roles.component.html',
    styleUrls: ['./list-roles.component.scss']
})
export class ListRolesComponent implements OnInit {

    ROWS = TABLES_CONFIG.ROW_NUMBER

    // Defines if all the needed resources has load
    resourcesHasLoaded: boolean = false;
    isAuthorized: boolean = true;

    displayedColumns: string[] = ['name', 'district', 'city', 'church', 'roles', 'actions'];
    dataSource = new MatTableDataSource<UserElement>();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // De donde se eleccionarán los roles a asignar
    rolesList: Array<Role> = [];

    constructor(
        private _memberService: MemberService,
        private _roleService: RolesService,
        private _dialog: MatDialog,
        private _loader: LoadService,
        private _feedback: UserFeedbackService
    ) { }

    ngOnInit() {
        this.loadAllUsers();

        // Obteniendo los roles del sistema
        this._roleService.getRolesAsList().subscribe((roles) => {

            // Convirtiendo en un array de objetos <role>
            this.rolesList = Object.keys(roles).map(function (roleIndex) {
                let rol = roles[roleIndex];
                return rol;
            });
        });
    }

    loadAllUsers() {
        this._memberService.getMembers().subscribe((members) => {

            var resultArray = Object.keys(members).map(function (memberIndex) {
                let member = members[memberIndex];
                member['roles'] = members[memberIndex]['roles'][0];
                return member;
            });

            this.dataSource = new MatTableDataSource<UserElement>(resultArray);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            this.resourcesHasLoaded = true
        })
    }

    modalEditRole(obj: any) {
        this._dialog.open(EditRoleComponent, {
            width: '33vw',
            data: {
                'currentUser': obj,
                'roleList': this.rolesList
            }
        }).afterClosed().subscribe((roleObj) => {
            let loader = this._loader.createLoad()
            loader.open()
            this._roleService.updateUseRole(roleObj).subscribe((response) => {
                console.log(response);
                this._feedback.openSnackbar({ message: response.toString() });
                loader.close();
                window.location.reload();
            }, error => {
                loader.close();
            })
        })
    }
}

export interface UserElement {
    name: string;
    surname: string;
    second_name: string;
    second_surname: string;
    city: {
        name: string;
    }
    distric: {
        name: string;
    }
    church: {
        name: string;
    }
    role: {
        name: string;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/pages/roles/list-roles/list-roles.component.ts